import * as React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import * as AiIcons from "react-icons/ai";
import { IconButton, Tooltip } from "@mui/material";
import { useState } from "react";
import axios from "axios";
import { springBaseUrl } from "../CalendarPage/constants/AmplitudeConstants";

export default function PrintChargeBackLoader({
  bookingId,
  apiUrl,
  toolTipText,
  children,
  sx,
}) {
  const [printLoading, setPrintLoading] = useState(false);
  const [printSuccess, setPrintSuccess] = useState(false);

  const handlePrintRegCard = (e) => {
    if (e) e.stopPropagation();
    setPrintLoading(true);
    setPrintSuccess(false);
    const finalApiUrl = `${springBaseUrl}${apiUrl}`;
    axios
      .get(finalApiUrl, {
        headers: {
          Accept: "application/pdf",
          Authorization: localStorage.getItem("token"),
        },
        responseType: "blob",
      })

      .then(async (response) => {
        setPrintLoading(false);
        setPrintSuccess(true);
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.src = url;
        document.body.appendChild(iframe);
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        setTimeout(() => setPrintSuccess(false), 3000);
      })
      .catch(() => {
        setPrintLoading(false);
      });
  };

  return (
    <Box sx={{ position: "relative", ...sx }} onClick={handlePrintRegCard}>
      {children ? (
        <Box
          sx={{ opacity: printLoading ? 0.6 : 1, transition: "opacity 0.2s" }}
        >
          {children}
        </Box>
      ) : (
        <div className="d-flex">
          <Tooltip title={toolTipText} placement="top">
            <IconButton onClick={handlePrintRegCard} disabled={printLoading}>
              {printSuccess ? (
                <AiIcons.AiOutlineCheckCircle size="27.5px" color="black" />
              ) : (
                <AiIcons.AiFillPrinter size="27.5px" color="black" />
              )}
            </IconButton>
          </Tooltip>
        </div>
      )}
      {printLoading && (
        <CircularProgress
          size={children ? 24 : 42}
          sx={{
            color: "primary.main",
            position: "absolute",
            top: "50%",
            left: "50%",
            marginTop: children ? "-12px" : "-21px",
            marginLeft: children ? "-12px" : "-21px",
            zIndex: 1,
          }}
        />
      )}
      {printSuccess && children && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            backgroundColor: "success.main",
            color: "white",
            borderRadius: "50%",
            width: 20,
            height: 20,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "12px",
            boxShadow: 2,
          }}
        >
          <AiIcons.AiOutlineCheck />
        </Box>
      )}
    </Box>
  );
}
